import React, { useState, useEffect, Fragment } from 'react';
import { Row, Card, CardBody } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { gAPI_AddOns_List } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CreateAddOnsForm from './components/forms/CreateAddOnsForm';
import UpdateAddOnsForm from './components/forms/UpdateAddOnsForm';
import TemplateAddOnButton from './components/forms/TemplateAddOnButton';
function Index({ propertyId, locale }) {
  const [addOnsList, setAddOnsList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    LoadData();
  }, [propertyId]);

  const LoadData = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_AddOns_List}/?propertyId=${propertyId}&status=all&languageCode=${locale}`,
    })
      .then(res => {
        setAddOnsList(res.data.addOns);
        setLoading(false);
      })
      .catch(err => console.log('err', err));
  }

  if (loading) {
    return (
      <Card className="d-flex flex-row mb-3">
        <CardBody>
          <h4 style={{ textAlign: 'center' }}>Loading...</h4>
        </CardBody>
      </Card>
    );
  }

  return (
    <Fragment>
      <Row>
        <Colxx xxs="6" className="mb-2">
          <CreateAddOnsForm />
        </Colxx>
        <Colxx xxs="6" className="mb-2">
          <TemplateAddOnButton LoadData={LoadData} />
        </Colxx>
      </Row>
      <Colxx xxs="12" className="mb-2 text-right">
        <strong><hr /></strong>
      </Colxx>
      <Row>
        {addOnsList.map((addOns, index) => (
          <Colxx xxs="12" key={index}>
            <Card className="d-flex flex-row mb-3">
              <img
                alt="Thumbnail"
                src={
                  addOns.images[0]
                    ? addOns.images[0].url
                    : 'https://via.placeholder.com/250x150'
                }
                className="list-thumbnail responsive border-0"
              />
              <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                  <p className="mb-1  text-small w-15 w-sm-100">
                    <b>{addOns.name}</b>
                  </p>
                  <p className="mb-1 text-muted text-small w-15 w-sm-100">
                    {addOns.displayText}
                  </p>
                  <p className="mb-1 text-muted text-small w-15 w-sm-100">
                    {addOns.displayFreeText}
                  </p>
                  <p className="mb-1 text-muted text-small w-15 w-sm-100">
                    {addOns.conditions}
                  </p>
                  <p className="mb-1 text-muted text-small w-15 w-sm-100">
                    {addOns.status}
                  </p>
                  <div className="w-15 w-sm-100">
                    <UpdateAddOnsForm id={addOns.id} propertyId={propertyId} />
                  </div>
                </div>
              </div>
            </Card>
          </Colxx>
        ))}
      </Row>

    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
